import { render, staticRenderFns } from "./inflections.vue?vue&type=template&id=100cb71b&"
import script from "./inflections.vue?vue&type=script&lang=js&"
export * from "./inflections.vue?vue&type=script&lang=js&"
import style0 from "./inflections.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/alpheios-core/alpheios-core/packages/components/node_modules/vue-loader/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('100cb71b')) {
      api.createRecord('100cb71b', component.options)
    } else {
      api.reload('100cb71b', component.options)
    }
    module.hot.accept("./inflections.vue?vue&type=template&id=100cb71b&", function () {
      api.rerender('100cb71b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "vue/components/inflections/inflections.vue"
export default component.exports